export default {
    get(name) {
        let data = localStorage.getItem(name)
        try {
            return JSON.parse(data)
        } catch (error) {
            return data
        }
    },
    set(name, data) {
        localStorage.setItem(name, JSON.stringify(data))
    },
    delete(name) {
        localStorage.removeItem(name)
    }
}